import Manager from 'coreClasses/Manager';
import ManagerRepository from 'coreClasses/ManagerRepository';

import {EEventType, IEventData} from './IEvents';
import NamespaceEventManager from './NamespaceEventManager';

/**
 * Represents EventsMgr
 */
class EventsMgr extends Manager {
	private namespaces: Map<string, NamespaceEventManager> = new Map();

	/**
	 * Represents EventsMgr
	 *
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @protected
	 */
	constructor(managerRepository: ManagerRepository) {
		super(managerRepository);
	}

	/**
	 * Returns namespace event manager
	 *
	 * @param {string} namespace - namespace
	 * @returns {NamespaceEventManager} - namespace event manager
	 */
	public getNamespace(namespace: string): NamespaceEventManager {
		if (!this.namespaces.has(namespace)) {
			this.namespaces.set(namespace, new NamespaceEventManager());
		}

		return this.namespaces.get(namespace);
	}

	/**
	 * Emits event
	 *
	 * @param {EEventType} eventType - event type
	 * @param {IEventData} eventData - event data
	 * @returns {void}
	 */
	emit(eventType: string | EEventType, eventData: IEventData): void {
		this.notify(eventType as unknown as string, eventData);
	}
}

export default EventsMgr;
